module.exports = __webpack_public_path__ + "img/light_bulb_white_border.f1242c0d.svg";